var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftLightBlackChevronIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7996 6.23966C12.0814 6.5432 12.0639 7.01775 11.7603 7.2996L8.85221 10L11.7603 12.7004C12.0639 12.9823 12.0814 13.4568 11.7996 13.7603C11.5177 14.0639 11.0432 14.0815 10.7397 13.7996L7.23966 10.5496C7.08684 10.4077 7 10.2086 7 10C7 9.79145 7.08684 9.59232 7.23966 9.45041L10.7397 6.20041C11.0432 5.91856 11.5177 5.93613 11.7996 6.23966Z",
    fill: "#A6A5A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLightBlackChevronIcon);
export default __webpack_public_path__ + "static/media/LeftLightBlackChevronIcon.814cf2117ab1cef19909b0893dfd739e.svg";
export { ForwardRef as ReactComponent };